// Campus photo for /colleges/seattle-university: CC BY-SA 4.0, by SaintIggy, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AChapel_of_St._Ignatius.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/seattle-university/; credited under the photo.
const photo = {
    "slug": "seattle-university",
    "alt": "The Chapel of St. Ignatius at Seattle University, a tan building with light towers, behind its reflecting pool under a blue sky with clouds",
    "src": "/colleges/seattle-university/campus-1600.webp",
    "srcSmall": "/colleges/seattle-university/campus-800.webp",
    "srcMid": "/colleges/seattle-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/seattle-university/og.jpg",
    "title": "Chapel of St. Ignatius",
    "author": "SaintIggy",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AChapel_of_St._Ignatius.JPG",
    "read": "2026-10-01"
};

export default photo;
